import { RESET_PASSWORD_TREATMENT_NAME } from '../constants';

function auth0Enabled(splits) {
  return splits && splits[RESET_PASSWORD_TREATMENT_NAME] && splits[RESET_PASSWORD_TREATMENT_NAME].treatment === 'on';
}
export default { auth0Enabled };
